import Communicate from './pages/Communicate';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Login from './pages/Login';
import PrivateRoute from './components/PrivateRoute';
import { AuthProvider } from './contexts/AuthContext';
import { Toaster } from 'react-hot-toast';
import Register from './pages/Register';
import Home from './pages/Home';
import AlertsPage from './pages/Alerts';
import ForgotPassword from './pages/ForgotPassword';

function App() {
  return (
    <div className="min-h-screen bg-background">
      <Router>
        <AuthProvider>
          <Routes>
            <Route
              path="/communicate/:serialNumber"
              element={<PrivateRoute component={Communicate} />}
            />
            <Route
              path="/alerts/:serial"
              element={<PrivateRoute component={AlertsPage} />}
            />
            <Route path="/" element={<PrivateRoute component={Home} />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot" element={<ForgotPassword />} />
          </Routes>
        </AuthProvider>
      </Router>
      <Toaster />
    </div>
  );
}

export default App;
